//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the Rock.CodeGeneration project
//     Changes to this file will be lost when the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
// <copyright>
// Copyright by the Spark Development Network
//
// Licensed under the Rock Community License (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.rockrms.com/license
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// </copyright>
//

/** System Group Types */
export const GroupType = {
    /** Application Group group type guid */
    GrouptypeApplicationGroup: "3981CF6D-7D15-4B57-AACE-C0E25D28BD49",
    /** Campus Team group type guid */
    GrouptypeCampusTeam: "BADD7A6C-1FB3-4E11-A721-6D1377C6958C",
    /** Communication List group type guid */
    GrouptypeCommunicationlist: "D1D95777-FFA3-CBB3-4A6D-658706DAED33",
    /** Event Attendees group type guid */
    GrouptypeEventattendees: "3311132B-268D-44E9-811A-A56A0835E50A",
    /** Family group type guid */
    GrouptypeFamily: "790E3215-3B10-442B-AF69-616C0DCB998E",
    /** Fundraising Opportunity group type guid */
    GrouptypeFundraisingopportunity: "4BE7FC44-332D-40A8-978E-47B7035D7A0C",
    /** General group type guid */
    GrouptypeGeneral: "8400497B-C52F-40AE-A529-3FCCB9587101",
    /** Know relationship group type guid */
    GrouptypeKnownRelationships: "E0C5A0E2-B7B3-4EF4-820D-BBF7F9A374EF",
    /** Organization Unit group type guid */
    GrouptypeOrganizationUnit: "AAB2E9F4-E828-4FEE-8467-73DC9DAB784C",
    /** Peer network group type guid */
    GrouptypePeerNetwork: "8C0E5852-F08F-4327-9AA5-87800A6AB53E",
    /** Security Role group type guid */
    GrouptypeSecurityRole: "AECE949F-704C-483E-A4FB-93D5E4720C4C",
    /** The Service Attendance group type guid */
    GrouptypeServiceAttendance: "77713830-AE5E-4B1A-94FA-E145DFF85035",
    /** The Services group type guid */
    GrouptypeServices: "235BAE2B-5760-4763-AADF-3938F34BA100",
    /** Serving Team group type guid */
    GrouptypeServingTeam: "2C42B2D4-1C5F-4AD5-A9AD-08631B872AC4",
    /** Sign-up Group group type guid */
    GrouptypeSignupGroup: "499B1367-06B3-4538-9D56-56D53F55DCB1",
    /** Small Group group type guid */
    GrouptypeSmallGroup: "50FCFB30-F51A-49DF-86F4-2B176EA1820B",
    /** Small Group Section group type guid */
    GrouptypeSmallGroupSection: "FAB75EC6-0402-456A-BE34-252097DE4F20",
    /** Organization Unit group type guid */
    GrouptypeWeeklyServiceCheckinArea: "FEDD389A-616F-4A53-906C-63D8255631C5",
};
